
import ClientMonitor from './ClientMonitor';

export default ClientMonitor;

// if (!window.sys_monitor) {
//     window.sys_monitor = new ClientMonitor();
// }